import AppLoader from '@/components/AppLoader';
import {
	ROUTE_DASHBOARD_BOOKING,
	ROUTE_DASHBOARD_BOOKINGS,
	ROUTE_DASHBOARD_BOOKING_PAGES,
	ROUTE_DASHBOARD_BOOKING_PAGE_HELPER,
	ROUTE_DASHBOARD_PARTNERS,
	ROUTE_DASHBOARD_PROFILE,
	ROUTE_DASHBOARD_TEAMS_PAGE,
	ROUTE_DASHBOARD_TEAM_DETAILS,
	ROUTE_MICROSOFT_REDIRECT,
	ROUTE_ONBOARDING_WELCOME,
	ROUTE_RESOURCES,
	ROUTE_RESOURCES_DETAILS,
	ROUTE_RESOURCES_GROUP_DETAILS,
	ROUTE_RESOURCE_GROUPS,
	ROUTE_ROOT_PAGES_LIST,
} from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import clientStateService from '@/services/clientState.service';
import AppShell from '@/templates/app-shell/app-shell.template';
import RequireAuth from '@/utils/RequireAuth';
import loadScript from '@/utils/loadScript';
import React, { Suspense } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import EventListPage from './components/pages/ServiceListPage/EventListPage';
import TeamPage from './components/pages/Team/team.page';
import TeamsPage from './components/pages/Teams/teams.page';

const BookingDetailsPage = React.lazy(() => import('./components/pages/BookingDetailsPage/BookingDetailsPage'));
const BookingsListPage = React.lazy(() => import('./components/pages/BookingListPage/BookingListPage'));
const PartnersPage = React.lazy(() => import('./components/pages/Partners/PartnersPage'));
const ProfileRouter = React.lazy(() => import('./components/pages/Profile/ProfileRouter'));
const ResourceDetailsPage = React.lazy(() => import('./components/pages/ResourceDetailsPage/ResourceDetailsPage'));
const ResourceGroupDetailsPage = React.lazy(
	() => import('./components/pages/ResourceGroupDetailsPage/ResourceGroupDetailsPage')
);
const ResourceGroupListPage = React.lazy(
	() => import('./components/pages/ResourceGroupListPage/ResourceGroupListPage')
);
const ResourcesPage = React.lazy(() => import('./components/pages/ResourcesPage/ResourcesPage'));
const RootPagesPage = React.lazy(() => import('./components/pages/RootPagesPage/RootPages.page'));
const BookingPageHelper = React.lazy(() => import('./components/pages/BookingPageHelper/BookingPageHelper'));

loadScript('https://upload-widget.cloudinary.com/global/all.js');

export default RequireAuth(function HomePage() {
	const { getCurrentUser, status } = useAuth();
	const location = useLocation();

	if (status === 'loading') {
		return <AppLoader />;
	}

	if (!clientStateService.decode(getCurrentUser().clientState).ob && location.pathname !== ROUTE_MICROSOFT_REDIRECT) {
		return <Redirect to={ROUTE_ONBOARDING_WELCOME} />;
	}

	return (
		<AppShell>
			<Suspense fallback={<AppLoader />}>
				<Switch>
					<Route path={ROUTE_DASHBOARD_PROFILE}>
						<ProfileRouter />
					</Route>

					<Route exact path={ROUTE_DASHBOARD_BOOKING_PAGES}>
						<EventListPage />
					</Route>

					<Route exact path={ROUTE_DASHBOARD_BOOKINGS}>
						<BookingsListPage />
					</Route>

					<Route exact path={ROUTE_DASHBOARD_PARTNERS}>
						<PartnersPage />
					</Route>

					<Route exact path={ROUTE_DASHBOARD_BOOKING}>
						<BookingDetailsPage />
					</Route>

					<Route strict path={ROUTE_RESOURCES_DETAILS}>
						<ResourceDetailsPage />
					</Route>

					<Route strict path={ROUTE_RESOURCES}>
						<ResourcesPage />
					</Route>

					<Route strict path={ROUTE_RESOURCES_GROUP_DETAILS}>
						<ResourceGroupDetailsPage />
					</Route>

					<Route strict path={ROUTE_RESOURCE_GROUPS}>
						<ResourceGroupListPage />
					</Route>

					<Route exact strict path={ROUTE_ROOT_PAGES_LIST}>
						<RootPagesPage />
					</Route>

					<Route exact strict path={ROUTE_DASHBOARD_BOOKING_PAGE_HELPER}>
						<BookingPageHelper />
					</Route>

					<Route exact strict path={ROUTE_DASHBOARD_TEAMS_PAGE}>
						<TeamsPage />
					</Route>

					<Route exact strict path={ROUTE_DASHBOARD_TEAM_DETAILS}>
						<TeamPage />
					</Route>


					<Redirect to={ROUTE_DASHBOARD_BOOKING_PAGES} />
				</Switch>
			</Suspense>
		</AppShell>
	);
});
